/**
 * Importacao do i18n para internacionalização.
 * @Documentacao i18n: https://kazupon.github.io/vue-i18n/started.html#javascript
 */

// Create VueI18n instance with options
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '../src/locales/en.json'
import es from '../src/locales/es.json'
import pt from '../src/locales/pt.json'

Vue.use(VueI18n)

const messages = {
	en,
	es,
	pt,
}

const idioma =
	localStorage.getItem('idioma') != null
		? localStorage.getItem('idioma')
		: navigator.language.substring(0, 2).toLowerCase()
if (idioma !== 'pt' && idioma !== 'es' && idioma !== 'en') {
	localStorage.removeItem('idioma')
	localStorage.setItem('idioma', 'pt')
} else {
	localStorage.setItem('idioma', idioma)
}

const i18n = new VueI18n({
	locale: idioma,
	fallbackLocale: idioma,
	messages,
})

export default i18n
